let snackbarUid = 0
const MAX_SNACKBAR_MESSAGES = 5
const SNACKBAR_TYPE_BY_COLOR = {
  red: 'error',
  error: 'error',
  green: 'success',
  success: 'success',
  warning: 'warning',
  orange: 'warning',
  info: 'info',
}

const state = {
  companyName: process.env.VUE_APP_COMPANY_NAME || 'FAKT',
  showMainAside: true,
  showProfileDrawer: false,
  showHeader: true,
  showFloatingButtons: true,
  snackbarMessages: [],
  ordersAmount: 0,
  currentRoute: {},
  currentRequestFilialId: null,
  currentRequestRegionId: null,
  yandexMapsYandexMapsApiKey: process.env.VUE_APP_YANDEX_MAPS_API_KEY || '',

  allowPageExitWithoutConfirm: false,
  showConfirmBeforePageExit: false,

  indicateFilialConnectionStatus: true,

  pageTitle: null,

  items: [
    {
      title: 'Консоль',
      icon: 'mdi-view-dashboard',
      to: '/',
    },
    {
      title: 'Филиалы',
      icon: 'mdi-assistant',
      to: '/entities/branches',
    },
    {
      title: 'Заказы',
      icon: 'fa-shopping-basket',
      to: '/',
    },
    {
      title: 'Пользователи',
      icon: 'mdi-face',
      items: [
        {
          title: 'Клиенты',
          to: '/clients',
        },
        {
          title: 'Сотрудники',
          to: '/staff',
        },
        {
          title: 'Роли',
          to: '/roles',
        },
      ],
    },
    {
      title: 'Справочники',
      icon: 'mdi-image',
      items: [
        { title: 'Категории', to: '/entities/categories' },
        { title: 'Меню', to: '/menu' },
        { title: 'Модификаторы', to: '/modifications' },
        { title: 'Технические карты', to: '/technicalcards' },
      ],
    },

  ],
  timezones: [
    { value: 'UTC+3', title: 'МСК (UTC+3)' },
    { value: 'UTC+2', title: 'МСК−1 (UTC+2)' },
    { value: 'UTC+4', title: 'МСК+1 (UTC+4)' },
    { value: 'UTC+5', title: 'МСК+2 (UTC+5)' },
    { value: 'UTC+6', title: 'МСК+3 (UTC+6)' },
    { value: 'UTC+7', title: 'МСК+4 (UTC+7)' },
    { value: 'UTC+8', title: 'МСК+5 (UTC+8)' },
    { value: 'UTC+9', title: 'МСК+6 (UTC+9)' },
    { value: 'UTC+10', title: 'МСК+7 (UTC+10)' },
    { value: 'UTC+11', title: 'МСК+8 (UTC+11)' },
    { value: 'UTC+12', title: 'МСК+9 (UTC+12)' },
  ],

}

const mutations = {
  setCurrentRoute (state, route) {
    state.currentRoute = route
  },
  toggleAside (state, value) {
    state.showMainAside = value
  },
  // Старый API сохранён: color из миксина (red/info/warning/green) маппится на тип
  setSnackbar (state, payload) {
    if (!payload.value) {
      state.snackbarMessages = []
      return
    }
    const type = SNACKBAR_TYPE_BY_COLOR[payload.color] || 'info'
    state.snackbarMessages.push({
      id: ++snackbarUid,
      type,
      text: payload.text || '',
      timeout: Number(payload.timeout) || 5000,
    })
    if (state.snackbarMessages.length > MAX_SNACKBAR_MESSAGES) {
      state.snackbarMessages.shift()
    }
  },
  removeSnackbarMessage (state, id) {
    state.snackbarMessages = state.snackbarMessages.filter((message) => message.id !== id)
  },
  setOrdersAmount (state, payload) {
    state.ordersAmount = payload
  },
  showHeader (state) {
    state.showHeader = true
  },
  hideHeader (state) {
    state.showHeader = false
  },
  showProfileDrawer (state) {
    state.showProfileDrawer = true
  },
  hideProfileDrawer (state) {
    state.showProfileDrawer = false
  },
  setRequestFilialId (state, filialId) {
    console.log('==== setRequestFilialId = ', filialId)
    state.currentRequestFilialId = filialId
  },
  setRequestRegionId (state, regionId) {
    console.log('==== setRequestRegionId = ', regionId)
    state.currentRequestRegionId = regionId
  },
  showFloatingButtons (state) {
    state.showFloatingButtons = true
  },
  hideFloatingButtons (state) {
    state.showFloatingButtons = false
  },

  /** Диалог подтверждения закрытия страницы */
  setAllowPageExitWithoutConfirm (state, value) {
    state.allowPageExitWithoutConfirm = !!value
  },

  setShowConfirmBeforePageExit (state, value) {
    state.showConfirmBeforePageExit = !!value
  },
  /** ******** */

  setPageTitle (state, value) {
    state.pageTitle = value
  },
}

const getters = {
  appIsDev: (state) => process.env.VUE_APP_IS_DEV || false,
  getTimezones: (state) => state.timezones,
  getTimezoneTitle: (state) => (value) => {
    return state.timezones.find((zone) => zone.value === value)?.title || value
  },
  isNewOrderPage: (state) => {
    return state.currentRoute.name === 'newOrder'
  },
  isEditOrderPage: (state) => {
    return state.currentRoute.name === 'editOrder'
  },
  isFastOrderEditPage: (state) => {
    return state.currentRoute.name === 'fastOrderEdit'
  },
  getCompanyName: state => state.companyName,
  getRequestFilialId: state => state.currentRequestFilialId,
  getRequestRegionId: state => state.currentRequestRegionId,
  indicateFilialConnectionStatus: state => state.indicateFilialConnectionStatus,
}
const actions = {
  init: async ({ dispatch }) => {
    //
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
